


















































































import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ
// 共通機能
import ApiAccessBase from '@/CommonFeature/components/ApiAccessBase.vue';
import router from '@/router';
// 定数ファイル
import { CustomScreenName } from '../fixed/CustomScreenName';
// 共通モジュール
import { supervisingModule } from '@/store/modules/OperationSupervising';
import { routingControlModule } from '@/store/modules/RoutingControl';
import { traderInfoModule } from '../store/modules/TraderInfo';
import { ITraderKey } from '../store/dto/TraderInfo';
import { Constants } from '@/CommonUtils/fixed/Constants';
import { CustomConstants } from '../fixed/CustomConstants';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class TraderInfoSearch extends ApiAccessBase {
  // 拡張パネルの設定（検索条件）
  private searchPanel: number[] = [0];  //初期表示展開
  // ページネーション部品の初期値設定
  private page = 1;  // 初めに表示するページの番号（基本的に1で固定）
  private itemPerPage = 10; // 1ページあたりに表示するレコードの数
  private pageCount =  0; // ページカウントの初期化(0固定)
  // 検索結果ヘッダの設定
  private headers = [
    {
      text: '許可番号',
      align: 'center',
      sortable: true,
      value: 'licenseNo',
    },
    {
      text: '商号又は名称',
      align: 'center',
      sortable: true,
      value: 'companyName',
    },
    {
      text: '住所',
      align: 'center',
      sortable: true,
      value: 'addr',
    },
    {
      text: '電話番号',
      align: 'center',
      sortable: true,
      value: 'phone',
    },
  ];

  private created() {
    // getInit呼び出し
    this.apiAccess(CustomConstants.TRADER_INFO_SEARCH_INIT_PATH, Constants.API_METHOD_GET, false, false).then(
      (result) => {
        if ((result) === Constants.API_RESULT_SUCCES) {
          this.setAllVariablecolsState();
          if (traderInfoModule.GET_SEARCH_FLAG) {
            // モジュールから検索条件を取得して画面項目に格納
            // 再検索を行う
            this.formData = traderInfoModule.GET_SEARCH_CONDITION;
            this.syncFormDataToVariableCols();
            this.search();
          }
        }
      },
    );
  }

  private toInfo(param: ITraderKey) {
    // 遷移前に情報画面側での検索キーと、検索結果をモジュールに入れる
    // キーは↑のparamからとってくる dtoは別途せってい
    traderInfoModule.setTraderKey(param);
    traderInfoModule.setSearchCondtion(this.formData);
    traderInfoModule.changeSearchFlagOn();
    // 再表示フラグはここでtrue?
    router.push({name: CustomScreenName.TRADER_INFO});
  }

  private search() {
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    // this.moldingSendForm(this.$refs.form);
    // 検索イベント　番号か商号でLike検索　どちらかは必須入力
    this.apiAccess(CustomConstants.TRADER_INFO_SEARCH_PATH, Constants.API_METHOD_POST, true, true).then(
        (result) => {
          if ((result) === Constants.API_RESULT_SUCCES) {
            // 検索イベント後正常終了時に以下
            traderInfoModule.setSearchCondtion(this.formData);
            // 検索イベント終了時に再検索フラグを消す
            traderInfoModule.changeSearchFlagOff();
            // 一覧先頭へジャンプ
            this.hrefElement('searchResults', -130);
          }
        },
    );
}

  private clear() {
    // 検索条件と表のデータを消す
    this.resetForm(this.$refs.form);
    this.resultData = [];
    traderInfoModule.moduleReset();
  }

  private returnPrevious() {
    router.push({name: CustomScreenName.CE_MENU});
  }

}
